var slider = (function () {
    var controls;
    var numSlides;
    var glide;

    function init() {
        controls = document.querySelector('.glide__arrows');
        // Glide.js creates clones of slides, exclude these when counting them
        numSlides = document.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length;

        // Note: breakpoints below are also referred to in giveaway styles and
        // giveaway/head-styles snippet.
        glide = new Glide('.glide', {
            type: 'carousel',
            perView: Math.min(4, numSlides),
            breakpoints: {
                959: {
                    perView: Math.min(3, numSlides)
                },
                719: {
                    perView: Math.min(2, numSlides)
                },
                419: {
                    perView: Math.min(1, numSlides)
                }
            }
        });

        glide.mount();

        createMQListener('(max-width: 419px)', function () {
            if (numSlides <= 1) {
                disableSlider();
            }
            else {
                enableSlider();
            }
        });

        createMQListener('(min-width: 420px) and (max-width: 719px)', function () {
            if (numSlides <= 2) {
                disableSlider();
            }
            else {
                enableSlider();
            }
        });

        createMQListener('(min-width: 720px) and (max-width: 959px)', function () {
            if (numSlides <= 3) {
                disableSlider();
            }
            else {
                enableSlider();
            }
        });

        createMQListener('(min-width: 960px)', function () {
            if (numSlides <= 4) {
                disableSlider();
            }
            else {
                enableSlider();
            }
        });
    }

    function createMQListener(mqString, matchesCallback) {
        function listener(mq) {
            if (mq.matches) {
                matchesCallback();
            }
        };

        var mq = matchMedia(mqString);
        mq.addListener(listener);

        // Do initial check on page load
        listener(mq);
    }

    function disableSlider() {
        glide.disable();
        controls.style.display = 'none';
    }

    function enableSlider() {
        glide.enable();
        controls.style.display = 'block';
    }

    return {
        init: init
    };
}());

$(document).ready(function () {
    // Set up analytics
    var analyticsEvents = [
        // Newsletter participation method
        {
            'config': {
                'selector': '.newsletter-form.analytics--submit',
                'triggerOnlyOnce': true
            },
            'event':  {
                'eventCategory': 'giveaway',
                'eventAction': 'newsletter',
                'eventLabelSuffix': FN.vars.giveawaySlug
            }
        },
        // Review participation method
        {
            'config': {
                'selector': '.method-review__button.analytics--click',
                'waitBeforeDefault': true
            },
            'event':  {
                'eventCategory': 'giveaway',
                'eventAction': 'review',
                'eventLabelSuffix': FN.vars.giveawaySlug
            }
        },
        // Twitter participation method
        {
            'config': {
                'selector': '.method-tweet__button.analytics--click'
            },
            'event':  {
                'eventCategory': 'giveaway',
                'eventAction': 'tweet',
                'eventLabelSuffix': FN.vars.giveawaySlug
            }
        }
    ];
    FN.analytics.addConfiguredEvents(analyticsEvents);

    // Set up smooth scrolling
    $.scrollIt();

    // Set up product slider
    slider.init();

    // Set up newsletter signup form

    // Prefill "source[OS]" value
    if ($('input[name="signup[OS]"]').length > 0) {
        $('input[name="signup[OS]"]').val(FN.helpers.platform());
    }

    $('.' + FN.newsletterConfig.selectors.formClass).each(function (index, element) {
        FN.newsletterConfig.instances.push(new FN.newsletter(element));
    });

    // Set up tweet participation method
    var tweetButton = document.querySelector('.method-tweet__button');
    if (tweetButton) {
        tweetButton.addEventListener('click', function (event) {
            event.preventDefault();
            var tweetText = tweetButton.getAttribute('data-tweettext');
            FN.socialShare('twitter', null, tweetText);
        });
    }

    // Check if giveaway has expired — if so, hide participation method, show
    // "expired" method.
    // PHP outputs seconds since Unix epoch, Date() expects milliseconds
    var deadline = new Date(FN.vars.deadline * 1000);
    if (Date.now() >= deadline) {
        var participationMethod = document.querySelector('.method__container:not(.method__container--hidden)');
        var expiredMethod = document.querySelector('.method__container--hidden');

        participationMethod.classList.toggle('method__container--hidden');
        expiredMethod.classList.toggle('method__container--hidden');
    }
});
